import * as ProfileActionTypes from 'actiontypes/profile';
import ProfileService from 'services/ProfileService';

export default shareContent(new ProfileService());

export function shareContent(service) {
  return ({
    contentClass, contentKey, image, message,
  }) => async (dispatch) => {
    dispatch(shareContentRequest());
    try {
      const { data } = await service.share(contentClass, contentKey, image, message);
      dispatch(shareContentSuccess(data));
      return data;
    } catch (error) {
      dispatch(shareContentFailure(error));
    }
  };
}

const shareContentRequest = () => ({
  type: ProfileActionTypes.SHARE_CONTENT_REQUESTED,
  isFetching: true,
});

const shareContentSuccess = data => ({
  type: ProfileActionTypes.SHARE_CONTENT_SUCCESS,
  isFetching: false,
  shareMessageResponse: data.message,
});

const shareContentFailure = message => ({
  type: ProfileActionTypes.SHARE_CONTENT_FAILURE,
  isFetching: false,
});